import { html } from 'lit-html';

const template = (data) => html`
<div class="project-situation-map-legenda content">
	${data.getStatuses().length > 0 ? html`
		<ul class="project-situation-map-legenda-list">
			${data.getStatuses().map(status => html`
				<li><button
					data-active-status="${data.state.activeLegendaStatuses.filter(function(filterStatus){ return filterStatus.value === status.value; }).length > 0 ? 'active' : 'inactive'}"
					data-status="${status.value}"
					@click=${e => { data.updateLegendaStatus(e.target.getAttribute('data-status')); }}>
					${status.label}
				</button></li>`)}
		</ul>
	` : ''}
</div>
`;

export default template;